import { useQuery } from "react-query";
import { Get } from "src/apis/api";
import { ListResponseType, UnpaidCreditListItem } from "src/types";
import { create } from 'zustand'

export const useUnpayedTransactions = () => useQuery<{}, {}, ListResponseType<UnpaidCreditListItem>>({
    queryFn: () => Get('agent/transactions/credit/unpaid?page=1&per_page=1000'),
    queryKey: ['Get-Unpaied-Transaction']
})



interface DataType {
    selectedItems: Array<{ credit: UnpaidCreditListItem, crews: Array<string> }>

}


interface StoreType extends DataType {
    dispatch: (data: DataType) => void
}


export const useUnpaidCreditsStore = create<StoreType>((set) => ({
    selectedItems: [],
    dispatch: (newState: Partial<DataType>) => set((state) => ({ ...state, ...newState })),
}))
